"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.searchForTagInHierarchicalList = exports.updateTagInTagsHierarchicalList = exports.addTagToTagsHierarchicalList = exports.addTagToTagTypeHierarchicalList = exports.addTagToTagTypesFlatList = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addTagToTagTypesFlatList = function addTagToTagTypesFlatList(tagTypes, tagToAdd) {
  var newTagTypes = tagTypes;

  var indexOfTagType = _lodash["default"].findIndex(newTagTypes, function (tagType) {
    return tagType.id === tagToAdd.tagType.id;
  });

  if (indexOfTagType < 0) {
    return newTagTypes;
  }

  if (!newTagTypes[indexOfTagType].tags) {
    newTagTypes[indexOfTagType].tags = [];
  }

  newTagTypes[indexOfTagType].tags.push(tagToAdd);
  return newTagTypes;
};

exports.addTagToTagTypesFlatList = addTagToTagTypesFlatList;

var searchTreeAdding = function searchTreeAdding(tagToAdd, searchTag) {
  var checkTag = searchTag;

  if (tagToAdd.parentTag && tagToAdd.parentTag.id === checkTag.id) {
    if (!checkTag.children) {
      checkTag.children = [];
    }

    checkTag.children.push(tagToAdd);
  } else if (checkTag.children) {
    checkTag.children.forEach(function (t, index) {
      checkTag.children[index] = searchTreeAdding(tagToAdd, t);
    });
  }

  return checkTag;
};

var addTagToTagTypeHierarchicalList = function addTagToTagTypeHierarchicalList(tagTypes, tagToAdd) {
  var newTagTypes = tagTypes;

  if (!tagToAdd.parentTag) {
    // this is a root tag so assume adding to flat list
    return addTagToTagTypesFlatList(newTagTypes, tagToAdd);
  }

  var indexOfTagType = _lodash["default"].findIndex(newTagTypes, function (tagType) {
    return tagType.id === tagToAdd.tagType.id;
  });

  if (indexOfTagType < 0) {
    // tag type doesn't exist so return original list
    return newTagTypes;
  }

  if (!newTagTypes[indexOfTagType].tags) {
    // tag type doesn't have tags so no way to find parent
    newTagTypes[indexOfTagType].tags = [];
    return newTagTypes;
  }

  newTagTypes[indexOfTagType].tags.forEach(function (t, index) {
    newTagTypes[indexOfTagType].tags[index] = searchTreeAdding(tagToAdd, t);
  });
  return newTagTypes;
};

exports.addTagToTagTypeHierarchicalList = addTagToTagTypeHierarchicalList;

var addTagToTagsHierarchicalList = function addTagToTagsHierarchicalList(tags, tagToAdd) {
  var newTags = tags;

  if (!tagToAdd.parentTag) {
    // this is a root tag so assume adding to flat list
    newTags.push(tagToAdd);
    return newTags;
  }

  newTags.forEach(function (t) {
    var checkTag = t;

    if (tagToAdd.parentTag.id === checkTag.id) {
      if (!checkTag.children) {
        checkTag.children = [];
      }

      checkTag.children.push(tagToAdd);
    } else if (checkTag.children) {
      addTagToTagsHierarchicalList(checkTag.children, tagToAdd);
    }
  });
  return newTags;
};

exports.addTagToTagsHierarchicalList = addTagToTagsHierarchicalList;

var updateTagInTagsHierarchicalList = function updateTagInTagsHierarchicalList(tags, tagToUpdate, useOriginalChildren) {
  var newTags = tags;
  newTags.forEach(function (t, index) {
    if (t.id === tagToUpdate.id) {
      var oldChildren = newTags[index].children;
      var oldExpanded = newTags[index].expanded;
      newTags[index] = tagToUpdate;
      newTags[index].children = useOriginalChildren ? oldChildren : tagToUpdate.children;
      newTags[index].expanded = oldExpanded;
    }

    if (newTags[index].children) {
      newTags[index].children = updateTagInTagsHierarchicalList(newTags[index].children, tagToUpdate, useOriginalChildren);
    }
  });
  return newTags;
};

exports.updateTagInTagsHierarchicalList = updateTagInTagsHierarchicalList;

var searchForTagInHierarchicalList = function searchForTagInHierarchicalList(tag, tagIdToFind) {
  if (tag.id === tagIdToFind) {
    return tag;
  }

  if (tag.children) {
    var foundTag = null;
    var i;

    for (i = 0; foundTag == null && i < tag.children.length; i += 1) {
      foundTag = searchForTagInHierarchicalList(tag.children[i], tagIdToFind);
    }

    return foundTag;
  }

  return null;
};

exports.searchForTagInHierarchicalList = searchForTagInHierarchicalList;
var _default = {
  addTagToTagTypesFlatList: addTagToTagTypesFlatList,
  addTagToTagTypeHierarchicalList: addTagToTagTypeHierarchicalList,
  addTagToTagsHierarchicalList: addTagToTagsHierarchicalList,
  updateTagInTagsHierarchicalList: updateTagInTagsHierarchicalList,
  searchForTagInHierarchicalList: searchForTagInHierarchicalList
};
exports["default"] = _default;